import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import alertBannerCss from './bg-alert-banner.scss?inline';
import {SlBadge} from "@shoelace-style/shoelace";

export interface BgAlertBannerInterface {
}

const shoelaceElementFactory = (tagName: string) => {
    // Define a list of all Shoelace components being used
    customElements.define(tagName, SlBadge);
};

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */

@customElement('bg-alert-banner')
export class BgAlertBanner extends LitElement {

    constructor(args: BgAlertBannerInterface) {
        super();
        if (!args) {
            return
        }
    }

    @property()
    docsHint = '';
    
    render() {

        return html`
            <div class="bg-alert-banner">
                <i class="icon-info bg-alert-banner-icon"></i>
                <slot></slot>
            </div>`
    }

    static styles = [
        unsafeCSS(alertBannerCss)
    ]
}

declare global {
    interface HTMLElementTagNameMap {
        'bg-alert-banner': BgAlertBanner
    }
}
